import { FormattedMessage } from 'react-intl';

import {
  So5FixtureEvent,
  So5State,
} from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';
import {
  ClickAfterPurchase_Action,
  ClickInstantBuy_Flow,
} from '@sorare/core/src/protos/events/so5/shared/events';

import { AvailablePrimaryBuyForAPlayer } from '#src/components/primaryBuy/AvailablePrimaryBuyForAPlayer/index.tsx';

type Props = {
  playerSlug: string;
};

export const PrimaryBuyForAPlayer = ({ playerSlug }: Props) => {
  const { generateSportContextPath } = useSportContext();
  return (
    <AvailablePrimaryBuyForAPlayer
      origin={ClickInstantBuy_Flow.MATCH_VIEW}
      playerSlug={playerSlug}
      title={<FormattedMessage defaultMessage="Scouted!" />}
      description={<FormattedMessage defaultMessage="Ready for your Lineup." />}
      primaryBuyActions={{
        primary: {
          label: <FormattedMessage {...glossary.continue} />,
          action: ClickAfterPurchase_Action.CONTINUE,
        },
        secondary: {
          label: <FormattedMessage {...glossary.playInPro} />,
          to: generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE, {
            params: {
              eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
              fixture: So5State.UPCOMING.toLowerCase(),
            },
          }),
          action: ClickAfterPurchase_Action.PLAY_PRO,
        },
      }}
    />
  );
};
